import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import Buttons from "../../../../library/custom/button/Button";
import { InputField } from "../../../../library/custom/textBox/InputField";
import "./addCategory.scss";
import {
  ORG_ID,
  USERID,
  ISwitch,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  CLIENT_SATATUS_FILTER,
} from "../../../../constant/constant";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import { INSPECTION_ADMIN } from "../../../../constant/routeContant";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControl from "@mui/material/FormControl";
import NORow from "../../../../library/custom/noRow/noRow";
import { TableLoader } from "../../../../library/common/Loader";
import ReportRowManipulte from "../../shared/ReportRowManipulate";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { checkPrivileges } from "../../../../utils/rolesHelper";

import ServiceeFilterList from "../jha/serviceListFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import { InactiveClient } from "../../../../utils/helper";
import { useDebounce } from "../../../../utils/useDebounceSearch";
const AddSubCategory = ({
  onSubmit,
  getSubCategoriesList,
  getSubCategoriesListData,
  adminAddUpdateSubcategory,
  isLoading,
  recordsCount,
  getSubCategoriesListDates,
}) => {
  const [open, setOpen] = React.useState(false);
  const [modalData, setModalData] = useState();
  const handleClose = () => setOpen(false);
  const [addSubCategoryBox, setAddSubCategoryBox] = useState(false);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);

  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [subCategoryFilterData, setSubCategoryFilterData] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const debouncedSearch = useDebounce(search, 500);

  const [isTableLoading, setisTableLoading] = useState(false);
  const openFilter = Boolean(anchorEl);
  const id = openFilter ? "simple-popover" : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const [filterFormValue, setFilterFormValue] = useState({
    isActive: "",
  });

  const getActiveStatus = () => {
    if (filterFormValue.isActive === 1) return true;
    if (filterFormValue.isActive === 2) return false;
    return "";
  };
  const fetchSubCategories = (overrides = {}) => {
    const payload = {
      page: page + 1,
      pageSize,
      searchText: search,
      organisationId: ORG_ID(),
      allowPaging: true,
      isActive: getActiveStatus(),
      ...overrides,
    };

    getSubCategoriesListData(payload);
  };

  useEffect(() => {
    if (getSubCategoriesListDates?.filterObj) {
      setSearch(getSubCategoriesListDates?.filterObj?.searchText);
      setFilterFormValue({
        isActive:
          getSubCategoriesListDates?.filterObj?.isActive === true
            ? 1
            : getSubCategoriesListDates?.filterObj?.isActive === false
              ? 2
              : "",
      });
    }
  }, [getSubCategoriesListDates?.filterObj]);

  const addSubCategoryHandler = () => {
    if (InactiveClient()) return;
    setIsSubCategoryName(false);
    setAddSubCategoryBox(true);
  };

  const handleautoSearch = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setPage(0);

    fetchSubCategories({
      page: 1,
      pageSize: newSize,
    });
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);

    fetchSubCategories({
      page: newPage + 1,
    });
  };

  const [isSubmit, setIsSubmit] = useState(false);
  const [isCreateOperation, setIsCreateOperation] = useState(false);

  const intialState = {
    subCategoriesValue: "",
  };
  const [formValue, setFormValue] = useState(intialState);
  const [isSubCategoryName, setIsSubCategoryName] = useState(false);

  const handleChange = (subCategorieItem) => {
    if (InactiveClient()) return;
    setIsCreateOperation(false);
    const newCatList = [...getSubCategoriesList];
    newCatList.forEach((lists) => {
      if (lists.key == subCategorieItem.key) {
        lists.isActive = !lists.isActive;
        lists.checked = !lists.checked;
        lists.createdBy = parseInt(USERID);
      }
    });
    onSubmit({
      subcategories: newCatList,
      organisationId: ORG_ID(),
    });
  };

  const [errorsMsgShowActive, seterrorsMsgShowActive] = useState(false);
  const [errorsMsgShow, setErrorsMsgShow] = useState();

  function mappedData() {
    let errors = false;
    if (formValue?.subCategoriesValue.trim() === "") {
      setFormValue({
        ...formValue,
        subCategoriesValue: "",
      });
      seterrorsMsgShowActive(false);
      setIsSubCategoryName(true);
      errors = true;
    }
    if (errors) {
      return false;
    }

    const index = getSubCategoriesList?.findIndex(
      (obect) =>
        obect.value.toUpperCase() ===
        formValue?.subCategoriesValue.toUpperCase(),
    );
    if (index === -1) {
      seterrorsMsgShowActive(false);
      const subcategories = [
        {
          key: 0,
          value: formValue?.subCategoriesValue,
          isActive: true,
          createdBy: parseInt(USERID),
        },
      ];
      return { subcategories, organisationId: ORG_ID() };
    } else {
      seterrorsMsgShowActive(true);
      setErrorsMsgShow("Sub Category Name already added");
    }
  }

  const submitData = () => {
    if (InactiveClient()) return;
    const data = mappedData();
    if (!data) {
    } else {
      setIsSubmit(true);
      setIsCreateOperation(true);
      onSubmit(data);
    }
  };

  const handleEditOnClick = (modalData) => {
    if (InactiveClient()) return;
    setAddSubCategoryBox(false);
    setOpen(true);
    setModalData(modalData);
    setFormValue({
      subCategoriesValue: modalData?.value,
    });
  };

  const submitUpdateData = () => {
    const index = getSubCategoriesList?.findIndex(
      (obect) =>
        obect.value?.toUpperCase() ===
        formValue?.subCategoriesValue?.toUpperCase(),
    );

    if (formValue?.subCategoriesValue.trim() === "") {
      setFormValue({
        ...formValue,
        subCategoriesValue: "",
      });
      seterrorsMsgShowActive(false);
      setIsSubCategoryName(true);
    } else if (index === -1) {
      setOpen(false);
      setFormValue({
        ...formValue,
        subCategoriesValue: "",
      });
      setIsCreateOperation(false);
      const subcategories = [
        {
          key: modalData?.key,
          value: formValue?.subCategoriesValue,
          isActive: modalData?.isActive,
          createdBy: parseInt(USERID),
        },
      ];
      onSubmit({ subcategories, organisationId: ORG_ID() });
    } else {
      seterrorsMsgShowActive(true);
      setErrorsMsgShow("Sub Category Name already added");
    }
  };

  const dataBack = {
    title: "Back to Inspections",
    route: INSPECTION_ADMIN,
  };

  const [getSubCategoriesLists, setSubGetCategoriesLists] = useState([]);
  useEffect(() => {
    setSubGetCategoriesLists(getSubCategoriesList);
  }, [getSubCategoriesList]);

  useEffect(() => {
    if (
      adminAddUpdateSubcategory?.status === "SUCCESS" &&
      adminAddUpdateSubcategory?.isLoading === false
    ) {
      setIsSubmit(false);
      setIsSubCategoryName(false);
      setFormValue({
        ...formValue,
        subCategoriesValue: "",
      });

      if (isCreateOperation) {
        // Reset search, page, pageSize, and filters on Create
        setSearch("");
        setPage(0);
        setPageSize(PAGE_SIZE);
        setFilterFormValue({
          isActive: "",
        });
        fetchSubCategories({
          page: 1,
          pageSize: PAGE_SIZE,
          searchText: "",
          isActive: "",
        });
        setIsCreateOperation(false);
      } else {
        // Preserve current state on Edit/Status toggle
        fetchSubCategories({
          page: page + 1,
          pageSize: pageSize,
          searchText: search,
        });
      }
    }
  }, [adminAddUpdateSubcategory]);

  const columns = [
    { field: "value", headerName: "Sub Category Name", flex: 2 },
    { field: "dateOfLastUpdate", headerName: "Last Updated", flex: 1 },
    {
      flex: 1,
      field: "isActive",
      headerName: "Status",
      hide: !checkPrivileges([12, 4, 120]),
      renderCell: (rows) => (
        <Grid className="catListBox">
          <Grid className="closeIcon">
            <FormControl component="fieldset" variant="standard">
              <FormGroup className="isActiveBox">
                <FormControlLabel
                  control={
                    <ISwitch
                      checked={rows?.row.isActive ? rows?.row.isActive : false}
                      onChange={() => handleChange(rows?.row)}
                      name="status"
                    />
                  }
                />

                <div>{rows?.row?.isActive ? "Active" : "Inactive"}</div>
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      ),
    },
    {
      flex: 1,
      field: "icon",
      renderHeader: () => "",
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <>
            {checkPrivileges([12, 120, 121, 4]) && (
              <ReportRowManipulte
                rows={rows}
                editOnClick={() => handleEditOnClick(rows?.row)}
                edit
                editLabel="Edit Sub Category"
              />
            )}
          </>
        );
      },
    },
  ];

  function handleFilterApply() {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setAnchorEl(null);
    window.close();
    setPage(0);
    fetchSubCategories({
      page: 1,
    });
  }

  function handleFilterClear(params) {
    setFilterFormValue({
      assetType: "",
      isActive: "",
    });

    setSearch("");
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setAnchorEl(null);
    window.close();
    setPage(0);
    setPageSize(PAGE_SIZE);
    fetchSubCategories({
      page: 1,
      pageSize: PAGE_SIZE,
      searchText: "",
      isActive: "",
    });
  }

  useEffect(() => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);

    setPage(0);

    fetchSubCategories({
      page: 1,
      searchText: debouncedSearch,
    });
  }, [debouncedSearch]);

  return (
    <>
      <Grid className="inspectionOverRide">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Grid className="modalContainer">
            <Box className="modalBox">
              <div className="modalTitle">Edit Sub Category</div>

              <div className="modalInputBox">
                <InputField
                  type="text"
                  isRequired={true}
                  value={formValue?.subCategoriesValue}
                  onChange={(e) =>
                    setFormValue({
                      ...formValue,
                      subCategoriesValue: e.target.value,
                    })
                  }
                  // label="Create Category"
                  placeholder="Edit Category Here..."
                  isError={isSubCategoryName}
                  errorMsg={
                    isSubCategoryName ? "Sub Category Name is Required" : ""
                  }
                />
                {errorsMsgShowActive && (
                  <div className="errorMsg">{errorsMsgShow}</div>
                )}
              </div>
              <Grid container className="modalFooterBox">
                <Grid item lg={2} xs={12} sm={3} md={3}>
                  <Buttons
                    varientText={true}
                    label="Cancel"
                    onClick={handleClose}
                  />
                </Grid>
                <Grid item lg={2} xs={12} sm={3} md={3}>
                  <Buttons
                    varientContained={true}
                    label={"Save"}
                    onClick={submitUpdateData}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Modal>

        <Grid container item md={12} xs={12} className="addShadowBox">
          <Grid container className="confBox">
            <Grid item md={8.5} xs={12}>
              <div className="confTitile">Configure Sub Categories</div>
            </Grid>
            <Grid item md={3.5} xs={12}>
              {checkPrivileges([12, 120, 121, 4]) && (
                <Buttons
                  id="btnAddCategory"
                  label={"Add Sub Category"}
                  varientAddIconBlue={true}
                  onClick={() => addSubCategoryHandler()}
                />
              )}
            </Grid>
          </Grid>

          <Grid container>
            <Grid container item md={12} xs={12}>
              {addSubCategoryBox && (
                <Grid item container md={8} className="CategoriesBox">
                  <Grid item md={8} xs={8}>
                    <InputField
                      type="text"
                      isRequired={true}
                      value={formValue?.subCategoriesValue}
                      onChange={(e) =>
                        setFormValue({
                          ...formValue,
                          subCategoriesValue: e.target.value,
                        })
                      }
                      label="Create Sub Category"
                      placeholder="Create Sub Category Here..."
                      isError={isSubCategoryName}
                      errorMsg={
                        isSubCategoryName ? "Sub Category Name is Required" : ""
                      }
                    />
                    {errorsMsgShowActive && (
                      <div className="errorMsg">{errorsMsgShow}</div>
                    )}
                  </Grid>
                  <Grid
                    className="smallAddBtn"
                    item
                    lg={1.6}
                    md={3}
                    xs={3}
                    ml={3}
                    mt={4}
                  >
                    <Buttons
                      aria-describedby="dd"
                      variant="contained"
                      type="button"
                      name="btn"
                      label={"Add"}
                      id="btnAddEquipment"
                      varientAddIconBlue={true}
                      disabled={isSubmit ? true : false}
                      onClick={submitData}
                    ></Buttons>
                  </Grid>
                </Grid>
              )}
              <Grid item container md={12} className="CategoriesBox">
                <Grid item md={9} xs={8}>
                  <div className="filter_of_caselist">
                    <div className="searchcaseid">
                      <label htmlFor="search">
                        <span>
                          <SearchIcon />
                        </span>
                        <div>
                          <input
                            id="search"
                            placeholder="Search"
                            type="text"
                            value={search}
                            className=""
                            onChange={handleautoSearch}
                            autoComplete="off"
                          />
                        </div>
                      </label>
                    </div>

                    <div className="filter_btn">
                      <button
                        aria-describedby={id}
                        variant="contained"
                        type="button"
                        name="btn"
                        onClick={(e) => handleClick(e)}
                      >
                        <FilterListIcon id="icn" /> Filters
                      </button>
                    </div>
                  </div>

                  <ServiceeFilterList
                    id={id}
                    open={openFilter}
                    anchorEl={anchorEl}
                    handleClose={() => {
                      setAnchorEl(null);
                      window.close();
                    }}
                    handleApply={() => handleFilterApply()}
                    secondLabel="Status"
                    secondLebelFilter={CLIENT_SATATUS_FILTER}
                    secondLebelValue={filterFormValue.isActive}
                    firstLebelOnChanges={(e) =>
                      setFilterFormValue({
                        ...filterFormValue,
                      })
                    }
                    secondLebelOnChanges={(e) =>
                      setFilterFormValue({
                        ...filterFormValue,
                        isActive: e.target.value,
                      })
                    }
                    handleClear={() => handleFilterClear()}
                  />
                </Grid>
              </Grid>
              <Grid item md={12} className="CategoriesBox mt-0">
                <div className="desc_box row_uniq">
                  <div className="table_style_ui">
                    {isTableLoading ? (
                      ""
                    ) : (
                      <GridTable
                        getRowId={(r) => r.key}
                        rows={getSubCategoriesLists ?? []}
                        rowCount={recordsCount ?? 0}
                        columns={columns}
                        loading={isLoading}
                        checkboxSelection={false}
                        page={page}
                        pagination
                        pageSize={pageSize}
                        rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                        onPageSizeChange={handlePageSizeChange}
                        onPageChange={handlePagignation}
                        backIconButtonProps={{ disabled: false }}
                        disableSelectionOnClick
                        components={{
                          LoadingOverlay: TableLoader,
                          NoRowsOverlay: NORow,
                        }}
                      />
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <div className="insBackBtn">
            <BackBtn dataBack={dataBack} />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default AddSubCategory;
